module.exports = __webpack_public_path__ + "static/media/logo.31243b1e.png";